import { useState, useEffect } from 'react';
import {Form,message,Input,Radio} from 'antd';
import { STriggerModal } from 'shj-components';
import { audioRecordConformity } from '@/services/crmTool.ts'

const RecordConformity = (props) => {
    const { open = false, onCancel, data= {}, fn } = props
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        form.resetFields()
        if(data?.id){
            form.setFieldsValue(data)
        }else{
            onReset()
        }

    }, [data])
    const onFinish = () => {
        form.validateFields().then((values) => {
            onSubmit(values)
        })
    };
    const onSubmit = (values) => {
        if (loading) return;
        setLoading(true);
        audioRecordConformity({id: data?.id,...values})
            .then((res: any) => {
                message.success(res.data.message);
                fn && fn();
                onCancel();
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const onReset = () => {
        form.resetFields();
    };
    return (
        <STriggerModal
            title="评定通话"
            onReset={onReset}
            onFinish={onFinish}
            open={open}
            onCancel={onCancel}
            confirmLoading={loading}
        >
            <Form
                form={form}
                autoComplete="off"
                layout={'vertical'}
            >
                <Form.Item label="通话合格" name="isConformity" required rules={[{ required: true, message: '请选择' }]}>
                    <Radio.Group name="isConformity">
                        <Radio value={true}>合格</Radio>
                        <Radio value={false}>不合格</Radio>
                    </Radio.Group>
                </Form.Item>
                <Form.Item label="描述" name="conformityDescription" >
                    <Input.TextArea placeholder="请输入" style={{ width: '100%' }} maxLength={200} showCount />
                </Form.Item>
            </Form>
        </STriggerModal>
    )
}

export default RecordConformity;